import { BookingCarAttributes } from '~/shared/api'
import {
  fuelTypeEnumLabels,
  transmissionEnumLabels,
} from '~/shared/config/constants'
import { CalendarIcon } from '~/shared/ui/icons'
import { ChipWrapper, Chip } from './styled'

export type CharacteristicsProps = {
  carAttributes: BookingCarAttributes
}

export function Characteristics({ carAttributes }: CharacteristicsProps) {
  const rows = [
    { label: carAttributes.plateNumber },
    { label: 'График 7/0', icon: <CalendarIcon /> },
    { label: carAttributes.manufactureYear },
    { label: transmissionEnumLabels[carAttributes.transmission] },
    { label: fuelTypeEnumLabels[carAttributes.fuelType] },
    ...(carAttributes.digitalbox ? [{ label: 'Digitalbox' }] : []),
  ]

  return (
    <ChipWrapper>
      {rows.map(({ label, icon }, index) => (
        <Chip key={index}>
          {icon ? (
            <div style={{ marginRight: '6px', display: 'flex' }}>
              <CalendarIcon />
            </div>
          ) : undefined}
          {label}
        </Chip>
      ))}
    </ChipWrapper>
  )
}
